export const ClassesEndpoints = {
  List: '/v3/classes',
  Detail: (classId: string) => `/v3/classes/${classId}`,
  Price: (classId: string) => `/v3/classes/${classId}/price`,
  Checkout: (classId: string) => `/v3/classes/${classId}/checkout`,
  VerifyCheckout: (checkoutId: string) =>
    `/v3/classes/checkouts/${encodeURIComponent(checkoutId)}/verify`,
  Recordings: (classId: string) => `/v3/classes/${classId}/recordings`,
  RecordingPlayback: (classId: string, recordingId: string) =>
    `/v3/classes/${encodeURIComponent(classId)}/recordings/${encodeURIComponent(recordingId)}/playback`,
  SessionRoom: (classId: string, sessionId: string) =>
    `/v3/classes/${classId}/sessions/${sessionId}/room`,
  SessionMembers: (classId: string, sessionId: string) =>
    `/v3/classes/${classId}/sessions/${sessionId}/members`,
  SessionJoin: (classId: string, sessionId: string) =>
    `/v3/classes/${classId}/sessions/${sessionId}/join`,
  SessionHand: (classId: string, sessionId: string) =>
    `/v3/classes/${classId}/sessions/${sessionId}/hand`,
  SessionChat: (classId: string, sessionId: string) =>
    `/v3/classes/${classId}/sessions/${sessionId}/chat`,
  PlacementStart: (classId: string) => `/v3/classes/${classId}/placement/start`,
  PlacementFinish: (classId: string) => `/v3/classes/${classId}/placement/finish`
} as const
